<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :width="dialogWidth"
    :show-close="false"
    :custom-class="customClass"
  >
    <!-- 自定义头部 -->
    <div slot="title" class="dialog-custom-header">
      <div class="header-left">
        <span class="header-dot"></span>
        <span class="header-title">{{ siteData.dev_name || '空调控制器' }}</span>
      </div>
      <span :class="['header-status', siteData.online === 88 ? 'running' : '']">
        {{ siteData.online === 88 ? '在线':'离线' }}
      </span>
    </div>

    <div class="kt-control-body">
      <!-- ========== 左侧温控器面板（与ctrAir列表中完全一致） ========== -->
      <div class="thermostat-container" style="width:220px;flex-shrink:0">
        <!-- 显示屏幕（与ctrAir完全一致） -->
        <div
          :class="['display-screen', siteData.pwr && siteData.online === 88 ? 'screen-on' : '', siteData.online !== 88 ? 'offline' : '']">
          <div class="display-top">
            <div class="mode-section">
              <span class="t-label">模式</span>
              <span class="mode-text">{{ getModeText(siteData) }}</span>
            </div>
            <div v-if="(showLock || showDljLock) && siteData.kt_lock" class="mode-section">
              <span class="t-label">{{ currentLockLabel }}</span>
            </div>
            <div class="setting-section">
              <span class="t-label">设定</span>
              <span style="font-size:16px">{{
                  typeof siteData.temp_set === 'number' ? siteData.temp_set.toFixed(1):siteData.temp_set
                }}℃</span>
            </div>
          </div>

          <div class="main-temp">
            <span class="big-num">{{
                typeof siteData.temp === 'number' ? siteData.temp.toFixed(1):siteData.temp
              }}</span>
            <div class="temp-unit">
              <span>℃</span>
              <span class="sub-label">室内</span>
            </div>
          </div>

          <div class="display-bottom">
            <span>{{ siteData.pid !== 'york' ? (siteData.sf_pwr === 1 ? '阀开':'阀关'):' ' }}</span>
            <span>{{ siteData.uptime }}</span>
            <span>{{ getFanText(siteData) }}</span>
          </div>
        </div>

        <!-- 底部按钮组（与ctrAir完全一致） -->
        <div class="button-group">
          <button class="control-btn" @click="onControl('pwr')">
            <i :class="siteData.pwr ? 'kt_pwr1' : 'kt_pwr'" style="font-size:16px"></i>
          </button>
          <button class="control-btn" @click="onControl('mode')">
            <i :class="siteData.pwr ? 'kt_mode1' : 'kt_mode'" style="font-size:16px"></i>
          </button>
          <button class="control-btn" @click="onControl('fan')">
            <i :class="siteData.pwr ? 'kt_fan1' : 'kt_fan'" style="font-size:16px"></i>
          </button>
          <button class="control-btn" @click="onControl('tempAdd')">
            <i :class="siteData.pwr ? 'kt_up1' : 'kt_up'" style="font-size:16px"></i>
          </button>
          <button class="control-btn" @click="onControl('tempDel')">
            <i :class="siteData.pwr ? 'kt_down1' : 'kt_down'" style="font-size:16px"></i>
          </button>
        </div>
      </div>

      <!-- ========== 右侧控制面板 ========== -->
      <div class="right-control-panel" :class="{'dlj-grid-layout': showDljLock}">
        <!-- 第一行：模式选择 + 锁定设置（普通）/ 多联机锁定（多联机） -->
        <div class="panel-row">
          <!-- 模式选择（始终显示） -->
          <div class="ctrl-block mode-block">
            <div class="block-title">
              <span class="title-bar title-blue"></span>
              <span>模式选择</span>
            </div>
            <div :class="['mode-btns', dynamicModeList.length <= 3 ? 'mode-btns-3col' : '']">
              <button
                v-for="m in dynamicModeList"
                :key="m.value"
                :class="['panel-btn', 'mode-btn', localMode === m.value ? 'active' : '']"
                @click="selectMode(m.value)"
              >{{ m.label }}
              </button>
            </div>
          </div>

          <!-- 锁定设置（普通模式） -->
          <div class="ctrl-block" v-if="showLock">
            <div class="block-title">
              <span class="title-bar title-yellow"></span>
              <span>锁定设置</span>
            </div>
            <div class="lock-btns">
              <button
                v-for="l in dynamicLockList"
                :key="l.value"
                :class="['panel-btn', 'lock-btn-item', localLock === l.value ? 'active' : '']"
                @click="selectLock(l.value)"
              >{{ l.label }}
              </button>
            </div>
          </div>

          <!-- 多联机锁定（第一行右侧，和锁定设置同一位置） -->
          <div class="ctrl-block dlj-lock-col" v-if="showDljLock">
            <div class="block-title">
              <span class="title-bar title-yellow"></span>
              <span>锁定功能</span>
            </div>
            <div class="dlj-lock-body">
              <div class="dlj-line">
                <span class="dlj-k">开关：</span>
                <div class="dlj-v">
                  <button v-for="o in [{v:1,l:'开机'},{v:0,l:'关机'},{v:null,l:'不锁'}]" :key="o.v"
                          :class="['dlj-mini',dljLockData.pwr===o.v?'on':'']"
                          @click="selectDljLock('pwr',o.v)">{{ o.l }}
                  </button>
                </div>
              </div>
              <div class="dlj-line">
                <span class="dlj-k">模式：</span>
                <div class="dlj-v">
                  <button v-for="m in dljModeList" :key="m.value"
                          :class="['dlj-mini',dljLockData.mode===m.value?'on':'']"
                          @click="selectDljLock('mode',m.value)">{{ m.label }}
                  </button>
                  <button :class="['dlj-mini',dljLockData.mode===null?'on':'']"
                          @click="selectDljLock('mode',null)">不锁
                  </button>
                </div>
              </div>
              <div class="dlj-line">
                <span class="dlj-k">风速：</span>
                <div class="dlj-v">
                  <button v-for="f in dljFanList" :key="f.value"
                          :class="['dlj-mini',dljLockData.fan===f.value?'on':'']"
                          @click="selectDljLock('fan',f.value)">{{ f.label }}
                  </button>
                  <button :class="['dlj-mini',dljLockData.fan===null?'on':'']"
                          @click="selectDljLock('fan',null)">不锁
                  </button>
                </div>
              </div>
              <div class="dlj-line">
                <span class="dlj-k">温度：</span>
                <div class="dlj-v dlj-temp">
                  <input class="dlj-inp" type="number" v-model.number="dljLockData.tempMin"/>
                  <span class="dlj-sep">~</span>
                  <input class="dlj-inp" type="number" v-model.number="dljLockData.tempMax"/>
                  <label class="dlj-cb"><input type="checkbox"
                                               v-model="dljLockData.lockTemp"/><span>锁定温度</span></label>
                </div>
              </div>
              <div class="dlj-btns">
                <button class="dlj-batch" @click="sendDljBatchUnlock">批量解锁</button>
                <button class="dlj-batch" @click="sendDljBatchLock">批量锁定</button>
              </div>
            </div>
          </div>
        </div>

        <!-- 第二行：风速调节 + 温度限制（始终显示，温度限制多联机时隐藏） -->
        <div class="panel-row">
          <!-- 风速调节（有温度限制时占50%，否则占100%） -->
          <div class="ctrl-block fan-block" :style="showTempLimit ? {flex:'0 0 50%',maxWidth:'50%'} : {}">
            <div class="block-title">
              <span class="title-bar title-green"></span>
              <span>风速调节</span>
              <span class="fan-current">{{ fanDisplayLabel }}</span>
            </div>
            <div class="fan-slider-container">
              <span class="fan-num">1</span>
              <div class="fan-track">
                <div class="fan-fill"
                     :style="{ left: '-3px', width: 'calc(' + (((localFan - 1) / (fanMax - 1) * 100)) + '% + 6px)' }"></div>
                <div
                  v-for="n in fanMax"
                  :key="n"
                  :class="['fan-dot', localFan >= n ? 'active' : '']"
                  :style="{ left: ((n - 1) / (fanMax - 1) * 100) + '%' }"
                ></div>
                <input
                  type="range"
                  min="1"
                  :max="fanMax"
                  v-model.number="localFan"
                  @change="onFanChange"
                  class="fan-range-input"
                />
              </div>
              <span class="fan-num">{{ fanMax }}</span>
            </div>
          </div>

          <!-- 温度限制（多联机时隐藏） -->
          <div class="ctrl-block" v-if="showTempLimit && !showDljLock">
            <div class="block-title">
              <span class="title-bar title-purple"></span>
              <span>温度限制</span>
            </div>
            <div class="temp-row">
              <input type="number" v-model.number="localTempMin" class="temp-input"
                     :min="tempLimit.minTemp" :max="tempLimit.maxTemp"/>
              <span class="temp-tilde">~</span>
              <input type="number" v-model.number="localTempMax" class="temp-input"
                     :min="tempLimit.minTemp" :max="tempLimit.maxTemp"/>
            </div>
            <button class="panel-send-btn" @click="sendTempLimit">发送</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部关闭按钮 -->
    <div slot="footer" class="dialog-custom-footer">
      <button class="log-btn" @click="showLogDialog">控制日志</button>
      <button class="close-btn" @click="closeDialog">关闭</button>
    </div>
  </el-dialog>

</template>

<script>
export default {
  name:'DiaKtCtr',
  props:{
    visible:{
      type:Boolean,
      default:false
    },
    siteData:{
      type:Object,
      default:() => ({})
    },
    pidModeMap:{
      type:Object,
      default:() => ({})
    },
    pidFanMap:{
      type:Object,
      default:() => ({})
    },
    pidLockMap:{
      type:Object,
      default:() => ({})
    },
    pidTempLimitMap:{
      type:Object,
      default:() => ({})
    },
    /* 多联机锁定显示控制 {pid: {show: true|false}} */
    pidDljLock:{
      type:Object,
      default:() => ({})
    },
    /* 主题标识：'1' 为浅色主题，其它为深色主题 */
    bj:{
      type:String,
      default:''
    }
  },
  data() {
    return {
      localMode:1,
      localFan:1,
      localLock:0,
      localTempMin:16,
      localTempMax:32,
      lockList:[
        {value:3,label:'全锁'},
        {value:1,label:'半锁'},
        {value:0,label:'解锁'}
      ],
      /* 多联机锁定数据 */
      dljLockData:{
        pwr:null,
        mode:null,
        fan:null,
        tempMin:17,
        tempMax:31,
        lockTemp:false
      },
      dljModeList:[
        {value:1,label:'制热'},
        {value:2,label:'制冷'},
        {value:3,label:'送风'},
        {value:4,label:'除湿'}
      ],
      dljFanList:[
        {value:1,label:'低风'},
        {value:2,label:'中风'},
        {value:3,label:'高风'},
        {value:0,label:'自动'}
      ]
    };
  },
  computed:{
    dialogVisible:{
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible',val);
      }
    },
    /* 多联机锁定内容较多，弹窗适当加宽 */
    dialogWidth() {
      return this.showDljLock ? '860px':'768px';
    },
    /* 弹窗主题类名 */
    customClass() {
      return this.bj === '1' ? 'kt-control-dialog theme-light':'kt-control-dialog';
    },
    /* 从pidModeMap字典读取模式列表 */
    dynamicModeList() {
      return this.pidModeMap[this.siteData.pid] || this.pidModeMap['default'];
    },
    /* 从pidFanMap字典读取最大风速档位 */
    fanMax() {
      return (this.pidFanMap[this.siteData.pid] || this.pidFanMap['default']).max;
    },
    /* 从pidFanMap字典读取风速显示文字 */
    fanDisplayLabel() {
      const cfg = this.pidFanMap[this.siteData.pid] || this.pidFanMap['default'];
      return cfg.labels[this.localFan] || `${this.localFan}档`;
    },
    /* 根据pidDljLock判断是否显示多联机锁定面板 */
    showDljLock() {
      const cfg = this.pidDljLock[this.siteData.pid] || this.pidDljLock['default'];
      return cfg ? cfg.show !== false:false;
    },
    /* 根据pidLockMap决定是否显示锁定设置（与多联机锁定互斥） */
    showLock() {
      if (this.showDljLock) return false;
      const cfg = this.pidLockMap[this.siteData.pid] || this.pidLockMap['default'];
      return cfg ? cfg.show !== false:true;
    },
    /* 根据pidLockMap获取当前PID的锁定选项列表 */
    dynamicLockList() {
      const cfg = this.pidLockMap[this.siteData.pid] || this.pidLockMap['default'];
      if (cfg && cfg.lockList && cfg.lockList.length > 0) {
        return cfg.lockList;
      }
      // 默认锁定选项
      return [
        {value:3,label:'全锁'},
        {value:1,label:'半锁'},
        {value:0,label:'解锁'}
      ];
    },
    /* 根据pidTempLimitMap决定是否显示温度限制（与多联机锁定互斥） */
    showTempLimit() {
      if (this.showDljLock) return false;
      const cfg = this.pidTempLimitMap[this.siteData.pid] || this.pidTempLimitMap['default'];
      return cfg ? cfg.show !== false:true;
    },
    /* 根据pidTempLimitMap获取当前PID的温度限制配置 */
    tempLimit() {
      return this.pidTempLimitMap[this.siteData.pid] || this.pidTempLimitMap['default'] || {minTemp:10,maxTemp:40};
    },
    /* 当前锁定类型的显示文字（从pidLockMap查找） */
    currentLockLabel() {
      const item = this.dynamicLockList.find(l => l.value === this.siteData.kt_lock);
      return item ? item.label:'锁定';
    }
  },
  watch:{
    siteData:{
      immediate:true,
      deep:true,
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.syncFromSiteData(newVal);
        }
      }
    }
  },
  methods:{
    syncFromSiteData(site) {
      if (site.mode !== undefined) {
        const modeList = this.pidModeMap[site.pid] || this.pidModeMap['default'];
        const modeValid = modeList.some(m => m.value === site.mode);
        this.localMode = modeValid ? site.mode:(modeList.length > 0 ? modeList[0].value:this.localMode);
      }
      if (site.fan_set !== undefined) {
        const cfg = this.pidFanMap[site.pid] || this.pidFanMap['default'];
        const display = this.fanSetToDisplay(site.fan_set,site.pid);
        const fanValid = display >= 1 && display <= cfg.max && cfg.displayToFanSet[display] !== undefined;
        this.localFan = fanValid ? display:1;
      }
      if (site.kt_lock !== undefined && this.showLock) {
        const lockItem = this.dynamicLockList.find(l => l.value === site.kt_lock);
        if (lockItem) {
          /* kt_lock 值与 pidLockMap 中某一项 value 精确匹配 */
          this.localLock = lockItem.value;
        } else if (site.kt_lock !== 0) {
          /* 未精确匹配且处于锁定状态，回退到第一个非解锁项（通常是全锁） */
          const firstLock = this.dynamicLockList.find(l => l.value !== 0);
          this.localLock = firstLock ? firstLock.value:0;
        } else {
          this.localLock = 0;
        }
      }
    },
    /* fan_set原始值 → 显示档位(从pidFanMap反向查找) */
    fanSetToDisplay(fanSet,pid) {
      const cfg = this.pidFanMap[pid] || this.pidFanMap['default'];
      for (const [display,raw] of Object.entries(cfg.displayToFanSet)) {
        if (raw === fanSet) return parseInt(display);
      }
      // 未找到匹配，返回最接近的档位
      return Math.max(1,Math.min(cfg.max,fanSet));
    },
    /* 显示档位 → fan_set原始值 */
    displayToFanSet(displayFan,pid) {
      const cfg = this.pidFanMap[pid] || this.pidFanMap['default'];
      return cfg.displayToFanSet[displayFan] !== undefined
        ? cfg.displayToFanSet[displayFan]
        :displayFan;
    },
    /* 从pidModeMap查找模式文字 */
    getModeText(site) {
      if (!site) return '--';
      const list = this.pidModeMap[site.pid] || this.pidModeMap['default'];
      const found = list.find(m => m.value === site.mode);
      return found ? found.label:'送风';
    },
    /* 从pidFanMap反向查找风速文字 */
    getFanText(site) {
      if (!site) return '--';
      const cfg = this.pidFanMap[site.pid] || this.pidFanMap['default'];
      // 根据fan_set原始值反查显示档位，再取labels
      const display = this.fanSetToDisplay(site.fan_set,site.pid);
      return cfg.labels[display] || `${display}档`;
    },
    selectMode(value) {
      this.localMode = value;
      this.$emit('control',{type:'mode',siteId:this.siteData.id,value:value});
    },
    /* 选择锁定类型并直接发送命令 */
    selectLock(value) {
      if (!this.showLock) return;
      this.localLock = value;
      this.$emit('sendLock',{
        siteId:this.siteData.id,
        lockValue:value
      });
    },
    /* 风速滑块变化直接发送命令 */
    onFanChange() {
      const fanSet = this.displayToFanSet(this.localFan,this.siteData.pid);
      this.$emit('control',{type:'fan',siteId:this.siteData.id,value:fanSet});
    },
    onControl(type) {
      this.$emit('control',{type,siteId:this.siteData.id});
    },
    sendLock() {
      this.$emit('sendLock',{
        siteId:this.siteData.id,
        lockValue:this.localLock
      });
    },
    sendTempLimit() {
      this.$emit('sendTempLimit',{
        siteId:this.siteData.id,
        tempMin:this.localTempMin,
        tempMax:this.localTempMax
      });
    },
    /* ========== 多联机锁定相关方法 ========== */
    selectDljLock(field,value) {
      this.dljLockData[field] = value;
    },
    sendDljBatchLock() {
      this.$emit('sendDljBatchLock',{
        siteId:this.siteData.id,
        wg_mac:this.siteData.wg_mac,
        wg_qid:this.siteData.wg_qid,
        pid:this.siteData.pid,
        pwr:this.dljLockData.pwr,
        mode:this.dljLockData.mode,
        fan:this.dljLockData.fan,
        tempMin:this.dljLockData.tempMin,
        tempMax:this.dljLockData.tempMax,
        lockTemp:this.dljLockData.lockTemp
      });
    },
    sendDljBatchUnlock() {
      this.$emit('sendDljBatchUnlock',{
        siteId:this.siteData.id,
        wg_mac:this.siteData.wg_mac,
        wg_qid:this.siteData.wg_qid,
        pid:this.siteData.pid
      });
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    showLogDialog() {
      this.$emit('showLog',this.siteData);
    }
  }
};
</script>

<style>
/* ===== 弹窗全局样式覆盖（非scoped，确保覆盖Element UI默认样式） ===== */
.kt-control-dialog .el-dialog {
  background: #283A4D !important;
  border-radius: 16px;
  border: 1px solid #3A506B;
  height: 65vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.kt-control-dialog .el-dialog__header {
  padding: 0;
  background: #283A4D;
  flex-shrink: 0;
}

.kt-control-dialog .el-dialog__body {
  padding: 0 20px 15px 20px;
  background: #283A4D;
  color: #ffffff;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.kt-control-dialog .el-dialog__footer {
  padding: 0 20px 20px 20px;
  border-top: none;
  background: #283A4D;
  flex-shrink: 0;
}

/* ========== 浅色主题覆盖 (bj="1") ========== */
.kt-control-dialog.theme-light .el-dialog,
.kt-control-dialog.theme-light .el-dialog__header,
.kt-control-dialog.theme-light .el-dialog__body,
.kt-control-dialog.theme-light .el-dialog__footer {
  background: #FFFFFF;
  color: #000000;
}

.kt-control-dialog.theme-light .el-dialog {
  border: 1px solid #C8CDD4;
}

.kt-control-dialog.theme-light .header-title {
  color: #000000;
}

.kt-control-dialog.theme-light .header-status {
  background: #E0E0E0;
  color: #5A6B7C;
}

.kt-control-dialog.theme-light .header-status.running {
  background: #27ae60;
  color: #FFFFFF;
}

.kt-control-dialog.theme-light .thermostat-container {
  background: linear-gradient(145deg, #F8F9FA 0%, #EDEFF2 100%);
  border-color: #C8CDD4;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

.kt-control-dialog.theme-light .display-screen {
  background: #A8B0A0;
  border-color: #9AA290;
}

.kt-control-dialog.theme-light .display-screen.screen-on {
  background: #E8EAE6;
  border-color: #C0C8C0;
  box-shadow: inset 0 0 16px rgba(0, 0, 0, 0.04);
}

.kt-control-dialog.theme-light .display-screen.screen-on::after {
  background: radial-gradient(ellipse at 30% 20%, rgba(13, 167, 200, 0.04) 0%, transparent 60%);
}

.kt-control-dialog.theme-light .display-screen.offline {
  opacity: 0.5;
}

.kt-control-dialog.theme-light .display-screen.offline .big-num,
.kt-control-dialog.theme-light .display-screen.offline .temp-unit span:first-child {
  color: #A0A8A0 !important;
}

.kt-control-dialog.theme-light .t-label {
  color: #6B767E;
}

.kt-control-dialog.theme-light .big-num {
  color: #8A928A;
}

.kt-control-dialog.theme-light .display-screen.screen-on .big-num {
  color: #0DA7C8;
  text-shadow: 0 0 16px rgba(13, 167, 200, 0.2), 0 0 40px rgba(13, 167, 200, 0.06);
}

.kt-control-dialog.theme-light .temp-unit > span:first-child {
  color: #8A928A;
}

.kt-control-dialog.theme-light .display-screen.screen-on .temp-unit > span:first-child {
  color: #0DA7C8;
}

.kt-control-dialog.theme-light .sub-label {
  color: #6B767E;
}

.kt-control-dialog.theme-light .display-screen.screen-on .sub-label {
  color: #283A4D;
}

.kt-control-dialog.theme-light .display-bottom {
  color: #6B767E;
  border-top-color: rgba(0, 0, 0, 0.08);
}

.kt-control-dialog.theme-light .display-screen.screen-on .display-bottom {
  color: #6B767E;
}

.kt-control-dialog.theme-light .setting-section > span:last-child {
  color: #6B767E;
}

.kt-control-dialog.theme-light .mode-text {
  color: #6B767E;
}

.kt-control-dialog.theme-light .display-screen.screen-on .mode-section .t-label,
.kt-control-dialog.theme-light .display-screen.screen-on .mode-section .mode-text,
.kt-control-dialog.theme-light .display-screen.screen-on .setting-section .t-label,
.kt-control-dialog.theme-light .display-screen.screen-on .setting-section > span:last-child,
.kt-control-dialog.theme-light .display-screen.screen-on .display-bottom span {
  color: #283A4D;
}

.kt-control-dialog.theme-light .control-btn {
  background: linear-gradient(145deg, #E8EAED 0%, #DEE0E4 100%);
  border-color: #B8BEC6;
  color: #909AA6;
}

.kt-control-dialog.theme-light .screen-on + .button-group .control-btn {
  color: #3A5A6E;
}

.kt-control-dialog.theme-light .control-btn:hover {
  border-color: #0DA7C8;
  color: #283A4D;
  background: linear-gradient(145deg, #D8E4E8 0%, #D0DCE2 100%);
  box-shadow: 0 0 10px rgba(13, 167, 200, 0.12);
}

.kt-control-dialog.theme-light .right-control-panel {
  background: linear-gradient(145deg, #F8F9FA 0%, #EDEFF2 100%);
  border-color: #C8CDD4;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

.kt-control-dialog.theme-light .block-title {
  color: #6B767E;
}

.kt-control-dialog.theme-light .panel-btn {
  background: linear-gradient(145deg, #E8EAED 0%, #DEE0E4 100%);
  border-color: #B8BEC6;
  color: #909AA6;
}

.kt-control-dialog.theme-light .panel-btn:hover {
  border-color: #0DA7C8;
  color: #283A4D;
}

.kt-control-dialog.theme-light .panel-btn.active {
  background: #0dA7C8;
  border-color: #0dA7C8;
  color: #ffffff;
}

.kt-control-dialog.theme-light .lock-btn-item.active {
  background: #E6A23C;
  border-color: #E6A23C;
  color: #ffffff;
}

.kt-control-dialog.theme-light .panel-send-btn {
  background: linear-gradient(145deg, #E8EAED 0%, #DEE0E4 100%);
  border-color: #B8BEC6;
  color: #909AA6;
}

.kt-control-dialog.theme-light .panel-send-btn:hover {
  border-color: #0DA7C8;
  color: #283A4D;
}

.kt-control-dialog.theme-light .fan-num {
  color: #6B767E;
}

.kt-control-dialog.theme-light .fan-track {
  background: #E0E4E8;
  border-color: #C8CDD4;
}

.kt-control-dialog.theme-light .fan-dot {
  background: #B8BEC6;
}

.kt-control-dialog.theme-light .temp-input {
  background: linear-gradient(145deg, #E8EAED 0%, #DEE0E4 100%);
  border-color: #B8BEC6;
  color: #283A4D;
}

.kt-control-dialog.theme-light .temp-input:focus {
  border-color: #0DA7C8;
}

.kt-control-dialog.theme-light .temp-tilde {
  color: #6B767E;
}

.kt-control-dialog.theme-light .dlj-k {
  color: #6B767E;
}

.kt-control-dialog.theme-light .dlj-mini {
  background: linear-gradient(145deg, #E8EAED 0%, #DEE0E4 100%);
  border-color: #B8BEC6;
  color: #909AA6;
}

.kt-control-dialog.theme-light .dlj-mini:hover {
  border-color: #0DA7C8;
  color: #283A4D;
}

.kt-control-dialog.theme-light .dlj-inp {
  background: linear-gradient(145deg, #E8EAED 0%, #DEE0E4 100%);
  border-color: #B8BEC6;
  color: #283A4D;
}

.kt-control-dialog.theme-light .dlj-inp:focus {
  border-color: #0DA7C8;
}

.kt-control-dialog.theme-light .dlj-sep {
  color: #6B767E;
}

.kt-control-dialog.theme-light .dlj-cb {
  color: #6B767E;
}

.kt-control-dialog.theme-light .dlj-batch {
  background: linear-gradient(145deg, #E8EAED 0%, #DEE0E4 100%);
  border-color: #B8BEC6;
  color: #909AA6;
}

.kt-control-dialog.theme-light .dlj-batch:hover {
  border-color: #0DA7C8;
  color: #283A4D;
}
</style>

<style scoped>
/* ===== 自定义头部 ===== */
.dialog-custom-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 20px 12px 20px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.header-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #0dA7C8;
  display: inline-block;
}

.header-title {
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
}

.header-status {
  font-size: 12px;
  padding: 4px 14px;
  border-radius: 12px;
  background: #3a4a5a;
  color: #8ba4be;
}

.header-status.running {
  background: #27ae60;
  color: #ffffff;
}

/* ===== 主体布局 ===== */
.kt-control-body {
  display: flex;
  gap: 18px;
  height: 100%;
  min-height: 0;
}

/* ===== 左侧温控器（使用ctrAir完全相同的样式） ===== */
/* --- 卡片外壳 --- */
.thermostat-container {
  border-radius: 16px;
  padding: 12px;
  font-family: "Microsoft YaHei", "Heiti SC", sans-serif;
  background: linear-gradient(145deg, #1C2E42 0%, #223244 100%);
  border: 1px solid #3A506B;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3),
  inset 0 1px 0 rgba(255, 255, 255, 0.05);
}

/* --- 中心显示屏 --- */
.display-screen {
  background: #121D2B;
  border: 1px solid #1E2F42;
  border-radius: 12px;
  padding: 12px;
  height: 140px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: all 0.4s ease;
  position: relative;
  overflow: hidden;
}

/* 屏幕开启时的微光效果 */
.display-screen.screen-on::after {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(ellipse at 30% 20%, rgba(0, 231, 255, 0.06) 0%, transparent 60%);
  pointer-events: none;
}

/* 离线状态 */
.display-screen.offline {
  opacity: 0.55;
}

.display-screen.offline .big-num {
  color: #4A5A6A !important;
}

.display-screen.offline .temp-unit span:first-child {
  color: #4A5A6A !important;
}

/* 屏幕内部布局 */
.display-top {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
}

.mode-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.setting-section {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}

.t-label {
  color: #5A7391;
  display: block;
  font-size: 11px;
}

/* --- 主温度数字 --- */
.main-temp {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin: -4px 0 12px 0;
}

.big-num {
  font-size: 40px;
  font-weight: 700;
  line-height: 1;
  color: #4A5A6A;
  letter-spacing: 2px;
}

/* 开机时温度数字 - 亮青色 */
.display-screen.screen-on .big-num {
  color: #00E5FF;
  text-shadow: 0 0 20px rgba(0, 229, 255, 0.3), 0 0 60px rgba(0, 229, 255, 0.1);
}

.temp-unit {
  font-size: 14px;
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}

.temp-unit > span:first-child {
  color: #4A5A6A;
}

.display-screen.screen-on .temp-unit > span:first-child {
  color: #00E5FF;
  opacity: 0.7;
}

.sub-label {
  display: block;
  color: #5A7391;
  font-size: 11px;
}

.display-screen.screen-on .sub-label {
  color: #FFFFFF;
}

.display-bottom {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  color: #5A7391;
  border-top: 1px solid #1A2638;
  padding-top: 8px;
  margin-top: 4px;
}

.display-screen.screen-on .display-bottom {
  color: #5A7391;
}

/* 关机时设定温度颜色与风速文字一致 */
.setting-section > span:last-child {
  color: #5A7391;
}

/* 开机时模式、设定温度、在线、时间、风速高亮为白色 */
.mode-text {
  color: #5A7391;
}

.display-screen.screen-on .mode-section .t-label,
.display-screen.screen-on .mode-section .mode-text,
.display-screen.screen-on .setting-section .t-label,
.display-screen.screen-on .setting-section > span:last-child,
.display-screen.screen-on .display-bottom span {
  color: #FFFFFF;
}

/* --- 底部按钮组 --- */
.button-group {
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
  gap: 8px;
}

.control-btn {
  flex: 1;
  height: 36px;
  background: linear-gradient(145deg, #1A2838 0%, #1E2D3D 100%);
  border: 1px solid #2E4056;
  border-radius: 8px;
  color: #4A6582;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: all 0.15s ease;
  padding: 0;
}

/* 开机状态：仅图标高亮 */
.screen-on + .button-group .control-btn {
  color: #C0D8E8;
}

.control-btn:hover {
  border-color: #0DA7C8;
  color: #E8F0F8;
  background: linear-gradient(145deg, #162536 0%, #1A2B3C 100%);
  box-shadow: 0 0 10px rgba(13, 167, 200, 0.15);
}

.control-btn:active {
  transform: scale(0.95);
}

/* ===== 右侧控制面板 ===== */
.right-control-panel {
  flex: 1;
  min-height: 0;
  background: linear-gradient(145deg, #1C2E42 0%, #223244 100%);
  border: 1px solid #3A506B;
  border-radius: 16px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3),
  inset 0 1px 0 rgba(255, 255, 255, 0.05);
  overflow: auto;
}

.panel-row {
  display: flex;
  gap: 10px;
}

.ctrl-block {
  flex: 1;
}

/* 多联机布局：模式在上、风速在下，锁定占右侧上下2格 */
.right-control-panel.dlj-grid-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto auto;
  gap: 16px 10px;
  align-items: start;
}

.dlj-grid-layout > .panel-row {
  display: contents;
}

.dlj-grid-layout .mode-block {
  grid-column: 1;
  grid-row: 1;
}

.dlj-grid-layout .fan-block {
  grid-column: 1;
  grid-row: 2;
}

.dlj-grid-layout .dlj-lock-col {
  grid-column: 2;
  grid-row: 1 / span 2;
}

/* 标题 */
.block-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  color: #8DA5BE;
  font-size: 13px;
}

.title-bar {
  width: 3px;
  height: 14px;
  border-radius: 2px;
  flex-shrink: 0;
}

.title-blue {
  background: #0dA7C8;
}

.title-yellow {
  background: #E6A23C;
}

.title-green {
  background: #67C23A;
}

.title-purple {
  background: #9b59b6;
}

.fan-current {
  margin-left: auto;
  color: #0dA7C8;
  font-size: 12px;
}

/* ===== 通用按钮样式 ===== */
.panel-btn {
  height: 34px;
  border-radius: 8px;
  border: 1px solid #2E4056;
  background: linear-gradient(145deg, #1A2838 0%, #1E2D3D 100%);
  color: #4A6582;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
  outline: none;
}

.panel-btn:hover {
  border-color: #0DA7C8;
  color: #C0D8E8;
}

.panel-btn.active {
  background: #0dA7C8;
  border-color: #0dA7C8;
  color: #ffffff;
}

/* 模式按钮网格 - 动态列数 */
.mode-btns {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.mode-btns-3col {
  grid-template-columns: 1fr 1fr 1fr;
}

.mode-btn {
  width: 100%;
}

/* 锁定按钮 1行3个 */
.lock-btns {
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
}

.lock-btn-item {
  flex: 1;
}

.lock-btn-item.active {
  background: #E6A23C;
  border-color: #E6A23C;
  color: #ffffff;
}

/* 发送按钮 */
.panel-send-btn {
  width: 100%;
  height: 34px;
  border-radius: 8px;
  border: 1px solid #2E4056;
  background: linear-gradient(145deg, #1A2838 0%, #1E2D3D 100%);
  color: #4A6582;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
}

.panel-send-btn:hover {
  border-color: #0DA7C8;
  color: #E8F0F8;
}

/* ===== 风速滑块 ===== */
.fan-slider-container {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 4px 0;
}

.fan-num {
  color: #5A7391;
  font-size: 11px;
  min-width: 14px;
  text-align: center;
}

.fan-track {
  flex: 1;
  position: relative;
  height: 20px;
  background: #121D2B;
  border: 1px solid #1E2F42;
  border-radius: 10px;
  overflow: visible;
}

.fan-fill {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 4px;
  background: #0dA7C8;
  border-radius: 2px;
  z-index: 1;
}

.fan-dot {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #2E4056;
  z-index: 2;
  transition: background 0.2s;
}

.fan-dot.active {
  background: #0dA7C8;
}

.fan-range-input {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  z-index: 3;
  margin: 0;
}

/* ===== 温度限制 ===== */
.temp-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.temp-input {
  flex: 1;
  height: 36px;
  border-radius: 8px;
  border: 1px solid #2E4056;
  background: linear-gradient(145deg, #1A2838 0%, #1E2D3D 100%);
  color: #C0D8E8;
  text-align: center;
  font-size: 14px;
  outline: none;
}

.temp-input:focus {
  border-color: #0DA7C8;
}

.temp-tilde {
  color: #5A7391;
  font-size: 14px;
}

/* ===== 多联机锁定（紧凑样式，和锁定设置同宽同高） ===== */
.dlj-lock-body {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.dlj-line {
  display: flex;
  align-items: center;
  gap: 6px;
  min-height: 26px;
}

.dlj-k {
  color: #8DA5BE;
  font-size: 12px;
  width: 38px;
  flex-shrink: 0;
  text-align: right;
  line-height: 1;
}

.dlj-v {
  display: flex;
  gap: 4px;
  flex: 1;
  flex-wrap: nowrap;
}

/* 迷你按钮 */
.dlj-mini {
  height: 26px;
  padding: 0 5px;
  border-radius: 5px;
  border: 1px solid #2E4056;
  background: linear-gradient(145deg, #1A2838 0%, #1E2D3D 100%);
  color: #4A6582;
  font-size: 11px;
  cursor: pointer;
  transition: all 0.2s;
  outline: none;
  flex: 1;
  min-width: 38px;
  white-space: nowrap;
}

.dlj-mini:hover {
  border-color: #0DA7C8;
  color: #C0D8E8;
}

.dlj-mini.on {
  background: #0DA7C8;
  border-color: #0DA7C8;
  color: #ffffff;
}

/* 温度行 */
.dlj-temp {
  display: flex;
  align-items: center;
  gap: 6px;
}

.dlj-inp {
  width: 48px;
  height: 26px;
  border-radius: 5px;
  border: 1px solid #2E4056;
  background: linear-gradient(145deg, #1A2838 0%, #1E2D3D 100%);
  color: #C0D8E8;
  text-align: center;
  font-size: 12px;
  outline: none;
  flex: none;
}

.dlj-inp:focus {
  border-color: #0DA7C8;
}

.dlj-sep {
  color: #5A7391;
  font-size: 12px;
}

/* 锁定温度复选框 */
.dlj-cb {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: 6px;
  cursor: pointer;
  color: #8DA5BE;
  font-size: 11px;
  white-space: nowrap;
}

.dlj-cb input[type="checkbox"] {
  width: 12px;
  height: 12px;
  accent-color: #0DA7C8;
  cursor: pointer;
  margin: 0;
}

/* 底部批量按钮 */
.dlj-btns {
  display: flex;
  gap: 8px;
  margin-top: 4px;
}

.dlj-batch {
  flex: 1;
  height: 30px;
  border-radius: 6px;
  border: 1px solid #2E4056;
  background: linear-gradient(145deg, #1A2838 0%, #1E2D3D 100%);
  color: #4A6582;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
}

.dlj-batch:hover {
  border-color: #0DA7C8;
  color: #E8F0F8;
}

/* ===== 底部关闭按钮 ===== */
.dialog-custom-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 5px;
}

.close-btn {
  padding: 8px 28px;
  border-radius: 8px;
  border: 1px solid #0dA7C8;
  background: transparent;
  color: #0dA7C8;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
}

.close-btn:hover {
  background: #0dA7C8;
  color: #ffffff;
}

.log-btn {
  padding: 8px 28px;
  border-radius: 8px;
  border: 1px solid #0dA7C8;
  background: transparent;
  color: #0dA7C8;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
}

.log-btn:hover {
  background: #0dA7C8;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/dialog/diaKtCtr.vue